import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3dd2e005&"
import script from "./Home.vue?vue&type=script&lang=ts&"
export * from "./Home.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd2e005')) {
      api.createRecord('3dd2e005', component.options)
    } else {
      api.reload('3dd2e005', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=3dd2e005&", function () {
      api.rerender('3dd2e005', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/Home.vue"
export default component.exports